import { render } from "./DropDownSpoiler.vue?vue&type=template&id=2422b769&scoped=true"
import script from "./DropDownSpoiler.vue?vue&type=script&lang=js"
export * from "./DropDownSpoiler.vue?vue&type=script&lang=js"

import "./DropDownSpoiler.vue?vue&type=style&index=0&id=2422b769&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2422b769"]])

export default __exports__